const arabic = {
  name: "Arabic",
  native_name: "العربية",
  code: "ar",
};

const ar = {
  translation: {
    report_bug: "الإبلاغ عن خطأ",
    import: "استيراد",
    file: "ملف",
    new: "جديد",
    new_window: "نافذة جديدة",
    open: "فتح",
    save: "حفظ",
    save_as: "حفظ باسم",
    save_as_template: "حفظ كقالب",
    template_saved: "تم حفظ القالب!",
    rename: "إعادة تسمية",
    delete_diagram: "حذف المخطط",
    are_you_sure_delete_diagram:
      "هل أنت متأكد أنك تريد حذف هذا المخطط؟ هذه العملية لا رجعة فيها.",
    oops_smth_went_wrong: "عفوًا! حدث خطأ ما.",
    import_diagram: "استيراد المخطط",
    import_from_source: "استيراد من SQL",
    export_as: "تصدير كـ",
    export_source: "تصدير SQL",
    models: "النماذج",
    exit: "خروج",
    edit: "تحرير",
    undo: "تراجع",
    redo: "إعادة",
    clear: "مسح",
    are_you_sure_clear:
      "هل أنت متأكد أنك تريد مسح المخطط؟ هذه العملية لا رجعة فيها.",
    cut: "قص",
    copy: "نسخ",
    paste: "لصق",
    duplicate: "تكرار",
    delete: "حذف",
    copy_as_image: "نسخ كصورة",
    view: "عرض",
    header: "شريط القوائم",
    sidebar: "الشريط الجانبي",
    issues: "مشكلات",
    presentation_mode: "وضع العرض",
    strict_mode: "وضع صارم",
    field_details: "تفاصيل الحقل",
    reset_view: "إعادة ضبط العرض",
    show_grid: "عرض الشبكة",
    show_cardinality: "عرض التعددية",
    theme: "السمة",
    light: "فاتح",
    dark: "داكن",
    zoom_in: "تكبير",
    zoom_out: "تصغير",
    fullscreen: "ملء الشاشة",
    settings: "الإعدادات",
    show_timeline: "عرض الجدول الزمني",
    autosave: "حفظ تلقائي",
    panning: "التحريك",
    show_debug_coordinates: "عرض إحداثيات التصحيح",
    transform: "تحويل",
    viewbox: "صندوق العرض",
    cursor_coordinates: "إحداثيات المؤشر",
    coordinate_space: "الفضاء",
    coordinate_space_screen: "الشاشة",
    coordinate_space_diagram: "المخطط",
    table_width: "عرض الجدول",
    language: "اللغة",
    flush_storage: "مسح التخزين",
    are_you_sure_flush_storage:
      "هل أنت متأكد أنك تريد مسح التخزين؟ سيؤدي هذا إلى حذف جميع مخططاتك والقوالب المخصصة بشكل لا رجعة فيه.",
    storage_flushed: "تم مسح التخزين",
    help: "مساعدة",
    shortcuts: "الاختصارات",
    ask_on_discord: "اسألنا على ديسكورد",
    feedback: "التعليقات",
    no_changes: "لا تغييرات",
    loading: "جارٍ التحميل...",
    last_saved: "آخر حفظ",
    saving: "جارٍ الحفظ...",
    failed_to_save: "فشل في الحفظ",
    fit_window_reset: "تكييف النافذة / إعادة ضبط",
    zoom: "تكبير",
    add_table: "إضافة جدول",
    add_area: "إضافة منطقة",
    add_note: "إضافة ملاحظة",
    add_type: "إضافة نوع",
    to_do: "مهام",
    tables: "جداول",
    relationships: "علاقات",
    subject_areas: "المجالات الموضوعية",
    notes: "ملاحظات",
    types: "أنواع",
    search: "بحث...",
    no_tables: "لا توجد جداول",
    no_tables_text: "ابدأ في بناء مخططك!",
    no_relationships: "لا توجد علاقات",
    no_relationships_text: "اسحب لربط الحقول وتشكيل العلاقات!",
    no_subject_areas: "لا توجد مجالات موضوعية",
    no_subject_areas_text: "أضف مجالات موضوعية لتجميع الجداول!",
    no_notes: "لا توجد ملاحظات",
    no_notes_text: "استخدم الملاحظات لتسجيل المعلومات الإضافية",
    no_types: "لا توجد أنواع",
    no_types_text: "اصنع أنواع البيانات المخصصة الخاصة بك",
    no_issues: "لم يتم اكتشاف أي مشكلات.",
    strict_mode_is_on_no_issues:
      "وضع صارم معطل لذا لن يتم عرض أي مشكلات.",
    name: "الاسم",
    type: "النوع",
    null: "فارغ",
    not_null: "غير فارغ",
    primary: "أساسي",
    unique: "فريد",
    autoincrement: "زيادة تلقائية",
    default_value: "القيمة الافتراضية",
    check: "تعبير الفحص",
    this_will_appear_as_is: "*سيظهر هذا في النص البرمجي المتولد كما هو.",
    comment: "تعليق",
    add_field: "إضافة حقل",
    values: "القيم",
    size: "الحجم",
    precision: "الدقة",
    set_precision: "تعيين الدقة: (الحجم، الأرقام)",
    use_for_batch_input: "استخدم , للإدخال الدفعي",
    indices: "المؤشرات",
    add_index: "إضافة مؤشر",
    select_fields: "تحديد الحقول",
    title: "العنوان",
    not_set: "غير معين",
    foreign: "خارجي",
    cardinality: "التعددية",
    on_update: "عند التحديث",
    on_delete: "عند الحذف",
    swap: "تبديل",
    one_to_one: "واحد إلى واحد",
    one_to_many: "واحد إلى كثير",
    many_to_one: "كثير إلى واحد",
    content: "المحتوى",
    types_info:
      "تم تصميم هذه الميزة لقواعد البيانات العلائقية الكائنية مثل PostgreSQL.\nإذا تم استخدامها مع MySQL أو MariaDB، سيتم توليد نوع JSON مع فحص التحقق المقابل.\nإذا تم استخدامها مع SQLite، سيتم تحويلها إلى BLOB.\nإذا تم استخدامها مع MSSQL، سيتم توليد نوع مستعار للحقل الأول.",
    table_deleted: "تم حذف الجدول",
    area_deleted: "تم حذف المنطقة",
    note_deleted: "تم حذف الملاحظة",
    relationship_deleted: "تم حذف العلاقة",
    type_deleted: "تم حذف النوع",
    cannot_connect: "لا يمكن الاتصال، الأعمدة لها أنواع مختلفة",
    copied_to_clipboard: "تم النسخ إلى الحافظة",
    create_new_diagram: "إنشاء مخطط جديد",
    cancel: "إلغاء",
    open_diagram: "فتح المخطط",
    rename_diagram: "إعادة تسمية المخطط",
    export: "تصدير",
    export_image: "تصدير الصورة",
    create: "إنشاء",
    confirm: "تأكيد",
    last_modified: "آخر تعديل",
    drag_and_drop_files: "اسحب وأسقط الملف هنا أو انقر للتحميل.",
    support_json_and_ddb: "تدعم ملفات JSON و DDB",
    upload_sql_to_generate_diagrams:
      "قم بتحميل ملف SQL لتوليد الجداول والأعمدة تلقائيًا.",
    overwrite_existing_diagram: "الكتابة فوق المخطط الحالي",
    only_mysql_supported:
      "*في الوقت الحالي، يتم دعم تحميل نصوص MySQL فقط.",
    blank: "فارغ",
    filename: "اسم الملف",
    table_w_no_name: "تم إعلان جدول بدون اسم",
    duplicate_table_by_name: "تكرار الجدول بالاسم '{{tableName}}'",
    empty_field_name: "اسم الحقل فارغ في الجدول '{{tableName}}'",
    empty_field_type: "نوع الحقل فارغ في الجدول '{{tableName}}'",
    no_values_for_field:
      "'{{fieldName}}' الحقل في الجدول '{{tableName}}' من النوع `{{type}}` ولكن لم يتم تحديد أي قيم",
    default_doesnt_match_type:
      "القيمة الافتراضية للحقل '{{fieldName}}' في الجدول '{{tableName}}' لا تتطابق مع نوعه",
    not_null_is_null:
      "'{{fieldName}}' الحقل في الجدول '{{tableName}}' ليس فارغًا ولكنه يحتوي على قيمة فارغة افتراضية",
    duplicate_fields:
      "حقول مكررة باسم '{{fieldName}}' في الجدول '{{tableName}}'",
    duplicate_index:
      "مؤشر مكرر بالاسم '{{indexName}}' في الجدول '{{tableName}}'",
    empty_index: "المؤشر في الجدول '{{tableName}}' لا يشير إلى أي أعمدة",
    no_primary_key: "الجدول '{{tableName}}' ليس له مفتاح أساسي",
    type_with_no_name: "تم إعلان نوع بدون اسم",
    duplicate_types: "أنواع مكررة بالاسم '{{typeName}}'",
    type_w_no_fields: "تم إعلان نوع فارغ '{{typeName}}' بدون حقول",
    empty_type_field_name: "اسم الحقل فارغ في النوع '{{typeName}}'",
    empty_type_field_type: "نوع الحقل فارغ في النوع '{{typeName}}'",
    no_values_for_type_field:
      "'{{fieldName}}' الحقل في النوع '{{typeName}}' من النوع `{{type}}` ولكن لم يتم تحديد أي قيم",
    duplicate_type_fields:
      "حقول مكررة بالاسم '{{fieldName}}' في النوع '{{typeName}}'",
    duplicate_reference: "مرجع مكرر بالاسم '{{refName}}'",
    circular_dependency: "اعتماد دائري يشمل الجدول '{{refName}}'",
    timeline: "الجدول الزمني",
    priority: "الأولوية",
    none: "لا شيء",
    low: "منخفض",
    medium: "متوسط",
    high: "مرتفع",
    sort_by: "ترتيب حسب",
    my_order: "ترتيبي",
    completed: "مكتمل",
    alphabetically: "أبجديًا",
    add_task: "إضافة مهمة",
    details: "التفاصيل",
    no_tasks: "ليس لديك أي مهام بعد.",
    no_activity: "ليس لديك أي نشاط بعد.",
    move_element: "نقل {{name}} إلى {{coords}}",
    edit_area: "{{extra}} تحرير المنطقة {{areaName}}",
    delete_area: "حذف المنطقة {{areaName}}",
    edit_note: "{{extra}} تحرير الملاحظة {{noteTitle}}",
    delete_note: "حذف الملاحظة {{noteTitle}}",
    edit_table: "{{extra}} تحرير الجدول {{tableName}}",
    delete_table: "حذف الجدول {{tableName}}",
    edit_type: "{{extra}} تحرير النوع {{typeName}}",
    delete_type: "حذف النوع {{typeName}}",
    add_relationship: "إضافة علاقة",
    edit_relationship: "{{extra}} تحرير العلاقة {{refName}}",
    delete_relationship: "حذف العلاقة {{refName}}",
    not_found: "لم يتم العثور على",
    pick_db: "اختر قاعدة البيانات",
    generic: "عام",
    generic_description:
      "يمكن تصدير المخططات العامة إلى أي نوع SQL ولكن تدعم أنواع بيانات قليلة.",
    enums: "القيم المعدودة",
    add_enum: "إضافة قيمة معدودة",
    edit_enum: "{{extra}} تحرير القيمة المعدودة {{enumName}}",
    delete_enum: "حذف القيمة المعدودة",
    enum_w_no_name: "تم العثور على قيمة معدودة بدون اسم",
    enum_w_no_values: "تم العثور على قيمة معدودة '{{enumName}}' بدون قيم",
    duplicate_enums: "قيم معدودة مكررة بالاسم '{{enumName}}'",
    no_enums: "لا توجد قيم معدودة",
    no_enums_text: "حدد القيم المعدودة هنا",
    declare_array: "إعلان مصفوفة",
    empty_index_name: "تم إعلان مؤشر بدون اسم في الجدول '{{tableName}}'",
    didnt_find_diagram: "عفوًا! لم يتم العثور على المخطط.",
  },
};

export { ar, arabic };
